import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import SettingsIcon from "@mui/icons-material/Settings";
import AssignmentIcon from "@mui/icons-material/Assignment";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import GroupsIcon from "@mui/icons-material/Groups";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import dayjs from "dayjs";
import Action from "../Components/common/Action";
import { Switch } from "@mui/material";

const adminInstituteListActions = [
  {
    key: "addDomains",
    title: "Add Domains",
    icon: <SettingsIcon />,
    modalType: "addDomains",
  },
  {
    key: "editUser",
    title: "Edit User",
    icon: <ModeEditIcon />,
    modalType: "editInstitute",
  },
  {
    key: "impersonate",
    title: "Login as an Institute",
    icon: <SwapHorizIcon />,
    modalType: "impersonate",
  },
  {
    key: "assignPlan",
    title: "Assign a Plan",
    icon: <AssignmentIcon />,
    modalType: "assignPlan",
  },
  //   ---------------------------------------delete institute------------------------
  //   {
  //     key: "deleteInstitute",
  //     title: "Delete Institute",
  //     icon: <DeleteIcon />,
  //     modalType: "deleteInstitute", // Make sure this matches modal type
  //   },
  //   -----------------------------------
];

export const adminInstituteListColumns = [
  {
    key: "instituteName",
    label: "Name",
  },
  { key: "Email", label: "Email" },
  {
    key: "origin",
    label: "Origin",
    render: (row) => (row?.origin ? row?.origin : "Web"),
  },
  { key: "totalQuantity", label: "Quantity" },
  { key: "Mobile", label: "Mobile No" },
  {
    key: "isSubscribed",
    label: "Subscription",
    render: (row) => (row?.isSubscribed ? "Active" : "Inactive"),
  },
  {
    key: "isBlocked",
    label: "Status",
    render: (row, handletoggle) => {
      return (
        <>
          <Switch
            checked={!row?.isBlocked}
            onChange={() => handletoggle(row)}
          />
          <span>{row?.isBlocked ? "Blocked" : "Unblocked"}</span>
        </>
      );
    },
  },
  {
    key: "createdAt",
    label: "Created Date",
    render: (row) => dayjs(row?.createdAt).format("YYYY/MM/DD"),
  },
  {
    key: "action",
    label: "Action",
    customClass: { textAlign: "center", width: "100px" },
    render: (row, handleOpenModal) => {
      return (
        <div className="d-flex justify-content-center">
          {adminInstituteListActions?.map((action, index) => (
            <Action
              key={index}
              row={row}
              handleOpenModal={() => handleOpenModal(action.modalType, row)}
              icon={
                row?.isPlanCreated && action.key === "assignPlan" ? (
                  <TaskAltIcon />
                ) : (
                  action.icon
                )
              }
              variant="contained"
              title={
                row?.isPlanCreated && action.key === "assignPlan"
                  ? "Edit Plan"
                  : action.title
              }
              btnColor={
                row?.isPlanCreated && action.key === "assignPlan"
                  ? "success"
                  : "primary"
              }
            />
          ))}
        </div>
      );
    },
  },
];

const adminInstitutePlanActions = [
  {
    title: "Delete Plan",
    icon: <DeleteIcon />,
    modalType: "deletePlan",
  },
  {
    title: "Edit Plan",
    icon: <ModeEditIcon />,
    modalType: "editPlan",
  },
];

export const adminInstitutePlanColumns = [
  {
    key: "name",
    label: "Name",
  },
  {
    key: "pricePerQty",
    label: "Price Per Qty",
    render: (data) => `$${data?.pricePerQty}`,
  },
  { key: "minimumQty", label: "Minimum Qty" },
  { key: "frequency", label: "Frequency " },
  { key: "planType", label: "Plan Type " },
  {
    key: "createdAt",
    label: "Created Date",
    render: (row) => dayjs(row?.createdAt).format("YYYY/MM/DD"),
  },
  {
    key: "action",
    label: "Action",
    customClass: { textAlign: "center", width: "100px" },
    render: (row, handleOpenModal) => {
      return (
        <div className="d-flex">
          {adminInstitutePlanActions?.map((action, index) => (
            <Action
              key={index}
              row={row}
              handleOpenModal={() => handleOpenModal(action.modalType, row)}
              icon={action.icon}
              variant="contained"
              title={action.title}
            />
          ))}
        </div>
      );
    },
  },
];

export const instituteSignUpColumns = [
  {
    label: "Institute Name",
    name: "iname",
    id: "iname",
    type: "text",
    required: true,
    errorKey: "Institute Name",
  },
  {
    label: "Institute Type",
    name: "itype",
    id: "itype",
    type: "text",
    required: true,
    errorKey: "Institute Type",
  },
  {
    label: "Phone",
    name: "phone",
    id: "phone",
    type: "phone",
    errorKey: "phone",
  },
  {
    label: "Email",
    name: "Email",
    id: "Email",
    type: "email",
    required: true,
    errorKey: "email",
  },
  {
    label: "Password",
    name: "Password",
    id: "inputPass",
    type: "password",
    required: true,
    errorKey: "password",
  },
  {
    label: "Confirm Password",
    name: "conPass",
    id: "confPass",
    type: "password",
    required: true,
    errorKey: "confirmPassword",
  },
];

const instituteProfessorCommonFields = [
  {
    label: "First Name",
    name: "Fname",
    id: "Fname",
    type: "text",
    required: true,
    errorKey: "fname",
  },
  {
    label: "Last Name",
    name: "Lname",
    id: "Lname",
    type: "text",
    required: true,
    errorKey: "lname",
  },
  {
    label: "Phone",
    name: "phone",
    id: "phone",
    type: "phone",
    errorKey: "phone",
  },
  {
    label: "Quantity",
    name: "totalQuantity",
    id: "totalQuantity",
    type: "number",
    required: true,
    errorKey: "totalQuantity",
  },
];

const emailField = {
  label: "Email",
  name: "email",
  id: "Email",
  type: "email",
  required: true,
  errorKey: "email",
};

export const createInstituteProfessorColums = [
  ...instituteProfessorCommonFields,
  emailField,
];

export const editInstituteProfessorColums = [
  ...instituteProfessorCommonFields.map((field) =>
    field.name === "phone" ? { ...field, isDisabled: true } : field,
  ),
  { ...emailField, isDisabled: true },
];

export const instituteProfessorListActions = [
  // {
  //     title: "Delete User",
  //     icon: <DeleteIcon />,
  //     modalType: "delete",
  // },
  {
    title: "Edit User",
    icon: <ModeEditIcon />,
    modalType: "edit",
  },
  // {
  //     title: "View Child Users",
  //     icon: <GroupsIcon />,
  //     modalType: "redirectToChildList",
  // },
];

export const instituteProfessorListColumns = [
  {
    key: "name",
    label: "Name",
    render: (row) => row?.Fname + " " + row?.Lname,
  },
  { key: "Email", label: "Email" },
  {
    key: "userType",
    label: "User Type",
    render: (row) => (row?.userType === "child" ? "Student" : row?.userType),
  },
  { key: "totalQuantity", label: "Quantity" },
  {
    key: "isBlocked",
    label: "Status",
    render: (row, handletoggle) => {
      return (
        <>
          <Switch
            checked={!row?.isBlocked}
            onChange={() => handletoggle(row, "status")}
          />
          <span>{row?.isBlocked ? "Blocked" : "Unblocked"}</span>
        </>
      );
    },
  },
  {
    key: "isActive",
    label: "Subscription",
    render: (row, handletoggle) => {
      return (
        <>
          <Switch
            checked={row?.isActive}
            onChange={() => handletoggle(row, "subscription")}
          />
          <span>{row?.isActive ? "Revoke" : "Restore"}</span>
        </>
      );
    },
  },
  {
    key: "createdAt",
    label: "Created Date",
    render: (row) => dayjs(row?.createdAt).format("YYYY/MM/DD"),
  },
  {
    key: "action",
    label: "Action",
    customClass: { textAlign: "center" },
    render: (row, handleOpenModal) => {
      return (
        <div className="d-flex justify-content-center">
          {instituteProfessorListActions?.map((action, index) => (
            <Action
              key={index}
              row={row}
              handleOpenModal={() => handleOpenModal(action.modalType, row)}
              icon={action.icon}
              variant="contained"
              title={action.title}
              isDisabled={row.userType === "child" ? true : false}
            />
          ))}
        </div>
      );
    },
  },
];

// This used in the Readmax admin dashboard to professor childs.
export const adminInstituteProfessorChildListColumns = [
  {
    key: "name",
    label: "Name",
    render: (row) => row?.Fname + " " + row?.Lname,
  },
  {
    key: "username",
    label: "Username",
    render: (row) => row?.username || "N/A",
  },
  {
    key: "parentEamil",
    label: "Parent Email",
    render: (row) => row?.parentDetails?.Email || "N/A",
  },
  {
    key: "instituteEmail",
    label: "Institute Email",
    render: (row) => row?.instituteEmail || "N/A",
  },
  {
    key: "isActive",
    label: "Status",
    render: (row) => {
      return <span>{row?.isActive ? "Active" : "Inactive"}</span>;
    },
  },
  {
    key: "createdAt",
    label: "Created Date",
    render: (row) => dayjs(row?.createdAt).format("YYYY/MM/DD"),
  },
];

// ----------------- Professor -----------------
// Colums and actions for Professor Dashboard.
export const instituteProfessorChildListActions = [
  {
    title: "Delete User",
    icon: <DeleteIcon />,
    modalType: "delete",
  },
  {
    title: "Edit User",
    icon: <ModeEditIcon />,
    modalType: "edit",
  },
  // {
  //     title: "View Child Users",
  //     icon: <GroupsIcon />,
  //     modalType: "redirectToChildList",
  // },
];

export const instituteProfessorChildListColumns = [
  {
    key: "studentId",
    label: "Student Id",
    render: (row) => (row.studentId ? row.studentId : "N/A"),
  },
  {
    key: "name",
    label: "Name",
    render: (row) => row?.Fname + " " + row?.Lname,
  },
  {
    key: "email",
    label: "email",
    render: (row) => (row?.email ? row.email : "N/A"),
  },
  {
    key: "username",
    label: "Username",
    render: (row) => (row.username ? row.username : "N/A"),
  },
  {
    key: "isActive",
    label: "Status",
    render: (row, handletoggle) => {
      const displayChecked =
        row.loginMethod === "email" ? !row?.isBlocked : row?.isActive;
      const displayText = displayChecked ? "Unblocked" : "Blocked";

      return (
        <>
          <Switch
            checked={displayChecked}
            onChange={() => handletoggle(row, "status")}
          />
          <span>{displayText}</span>
        </>
      );
    },
  },
  {
    key: "createdAt",
    label: "Created Date",
    render: (row) => dayjs(row?.createdAt).format("YYYY/MM/DD"),
  },
  {
    key: "action",
    label: "Action",
    customClass: { textAlign: "center" },
    render: (row, handleOpenModal) => {
      return (
        <div className="d-flex justify-content-center">
          {instituteProfessorChildListActions?.map((action, index) => (
            <Action
              key={index}
              row={row}
              handleOpenModal={() => handleOpenModal(action.modalType, row)}
              icon={action.icon}
              variant="contained"
              title={action.title}
            />
          ))}
        </div>
      );
    },
  },
];
